function getCartAttributeProperties(formData) {
  const properties = {}

  for (const [key, value] of formData.entries()) {
    if (key.includes('properties') && !!value) {
      const strippedKey = key.replace('properties[', '').replace(']', '')
      properties[strippedKey] = value
    }
  }

  return properties
}

export function addItemById(
  formData = new FormData(),
  sections = 'cart-drawer',
) {
  const id = formData.get('id')
  const quantity = formData.get('quantity') ?? 1
  const properties = getCartAttributeProperties(formData)

  return fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{ id, quantity, properties }],
      sections,
    }),
  }).then((res) => res.json())
}

export function updateItemById({
  id,
  quantity,
  properties = {},
  sections = 'cart-drawer',
}) {
  return fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id, quantity, properties, sections }),
  }).then((res) => res.json())
}

export function fetchCart() {
  return fetch(`${window.Shopify.routes.root}cart.js`, {
    method: 'GET',
    credentials: 'include',
  }).then((res) => res.json())
}

export function updateCart(body, sections = 'cart-drawer') {
  return fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...body, sections }),
  }).then((res) => res.json())
}
